export const getUrl = function (params) {
  let rangeArr = []
  let param = ''
  if (params && typeof params === 'object') {
    if (rangeArr.length === 0) {
      rangeArr.push('?')
    }
    for (const i in params) {
      if (params.hasOwnProperty(i)) {
        if (params[i] !== '') {
          rangeArr.push(i)
          rangeArr.push('=')
          rangeArr.push(params[i])
          rangeArr.push('&')
        }
      }
    }
    param = rangeArr.join('').replace(/&$/, '')
  }
  return param
}



// WEBPACK FOOTER //
// ./src/utils/global/geturl.js